import type { ChannelBrand } from 'gcs-common/helper/channelTypeHelper';
import { useMemo } from 'react';
// import { CHANNEL_BRANDS } from 'gcs-common/helper/channelTypeHelper';
// import gcLogo from '../../img/gc-logo.svg';
// import gutLogo from '../../img/gut-logo.svg';

// TODO: enable all brand logos in the future
// const srcs = {
//   [CHANNEL_BRANDS.GC]: gcLogo,
//   [CHANNEL_BRANDS['G.U.T.']]: gutLogo,
// };

interface ChannelBrandLogoProps {
  channelBrand: ChannelBrand;
}
const ChannelBrandLogo = ({ channelBrand }: ChannelBrandLogoProps) => {
  const src = useMemo(() => {
    return undefined;
    // TODO: enable all brand logos in the future
    // return srcs[channelBrand];
  }, [channelBrand]);
  return src ? <img src={src} alt="brand" /> : null;
};

export default ChannelBrandLogo;
